// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/taco-playbits/playbits-top-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/taco-playbits/taco-playbits-mobile-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playbits-top-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 27.6vw;
}

.pointers-auth-icons-wrapper {
  border-right: 1px solid #cccccc;
  padding: 0 15%;
}

.playbits-auth-icons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 20px;
}

.playbits-auth-icons img {
  height: 120px;
  width: 120px;
}

.abt-playbits-pointers ul li {
  text-align: justify;
  padding-bottom: 20px;
}

.playbits-timeline-card {
  background-color: #e7e6ea;
  padding: 20px 30px;
  height: 200px;
  border-radius: 10px;
  border-bottom: 2px solid #c4c3c5;
  border-left: 2px solid #c4c3c5;
}

.playbits-card-title p {
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
}

.playbit-card-icon img {
  height: 50px;
  width: 50px;
  background-color: #cbcbcb;
}

.timeline-cards-wrapper::after {
  content: "";
  position: absolute;
  background-color: #cbcbcd;
  width: 95%;
  height: 3px;
  top: 47%;
  left: 3%;
}

/* Arrow Left */
.timeline-cards-wrapper::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #cbcbcd;
  top: 45.5%;
  left: 2%;
}

.timeline-cards-wrapper-copy {
  position: relative;
}

.timeline-cards-wrapper-copy::before {
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #cbcbcd;
  top: 98%;
  left: 14%;
}

.timeline-cards-wrapper-copy::after {
  bottom: -2%;
  top: auto;
  top: initial;
  width: 70%;
  left: 15%;
}

/* Arrow right  */
.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #cbcbcd;
  position: absolute;
  top: 45.5%;
  right: -5%;
}

.arrow-right-copy {
  top: 98%;
  right: 8%;
}
.timeline-cards-wrapper-copy {
  margin-top: 50px;
}

.playbit-card-icon {
  position: absolute;
  bottom: -15%;
  left: 35%;
  border-radius: 5px;
  width: 65px;
  padding: 7px;
}

.playbits-card-icon-a {
  background: linear-gradient(to right, #2662c6, #4352bc);
}

.playbits-card-icon-b {
  background: linear-gradient(to right, #4d4fbb, #6c42b0);
}

.playbits-card-icon-c {
  background: linear-gradient(to right, #7741ae, #993ea3);
}

.playbits-timeline-card::after {
  content: "";
  width: 20px;
  height: 20px;
  background-color: #cbcbcd;
  border-radius: 12px;
  border: 4px solid #6c42b0;
  position: absolute;
  left: 45%;
  bottom: -36%;
  z-index: 2;
}

.playbits-timeline-card-copy::after {
  bottom: -34%;
}

/* What will your child learn */
.child-learn {
  background-color: #f5f6fb;
}

.what-will-your-child-learn-txt-content,
.cstem-txt-content {
  padding: 0 10%;
}

.what-will-your-child-learn-txt-content ul li,
.cstem-txt-content ul li {
  text-align: justify;
  padding-bottom: 20px;
}

.cstem-txt-content ul li {
  color: var(--dPink);
}

.cstem-txt-content {
  border-right: 1px solid #000;
}

.cstem-txt-content ul li strong,
.cstem-txt-content ul li::marker {
  color: var(--dBlue);
}

.cstem-txt-row p {
  color: var(--dBlue);
  font-size: 18px;
  font-weight: 600;
}

/* Video section  */
.video-playbits-soft {
  background-color: #f5f6fb;
}

.rec-que-txt p {
  font-size: 18px;
  font-weight: 700;
}

.rec-que-txt p {
  color: var(--dBlue);
}

.software-download-txt-icon p {
  color: #5b5c5e;
  font-size: 16px;
  font-weight: 700;
}

.software-compatible-platforms {
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 70px;
}

.scp-img-a img,
.scp-img-b img {
  height: 70px;
  width: 70px;
}

.scp-img-a p,
.scp-img-b p {
  color: var(--dBlue);
  font-weight: 500;
}

.scp-img-a::after {
  content: "";
  position: absolute;
  background-color: #9fa0a5;
  width: 2px;
  height: 50px;
  left: 51%;
  top: 40%;
}

.wand-1-wrapper {
  background-color: #f5f6fb;
  padding: 30px 60px;
  border-radius: 15px;
  background-color: #f5f6fb;
  padding: 30px 60px;
  border-radius: 15px;
  width: 70%;
  margin: 0 auto;
}

.wand-sequence p {
  color: var(--dBlue);
  font-size: 25px;
  font-weight: 600;
}

.wand-icons {
  display: flex;
  flex-wrap: wrap;
  column-gap: 10%;
  justify-content: center;
}

.wand-icons img {
  height: 120px;
  width: 120px;
}

@media (max-width: 1024px) {
  .pointers-auth-icons-wrapper {
    border: medium none currentColor;
    border: initial;
    margin-bottom: 50px;
  }

  .wand-1-wrapper {
    width: 100%;
  }

  .cstem-gif-content {
    margin-bottom: 20px;
  }

  .cstem-txt-content {
    border: medium none currentColor;
    border: initial;
  }
}

@media (max-width: 576px) {
  .playbits-top-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 127.2vw;
  }

  .cstem-gif-content img {
    height: auto;
    width: 100%;
  }

  .playbits-video-tutorials {
    flex-wrap: wrap;
  }

  .pointers-auth-icons-wrapper {
    border-right: 0;
    border-right: initial;
    padding: 0;
    padding: initial;
  }

  .playbits-auth-icons {
    padding-top: 0;
    padding-top: initial;
  }

  .playbits-timeline-card {
    margin: 40px;
  }

  .timeline-cards-wrapper {
    padding-top: 30px;
  }

  .timeline-cards-wrapper::before,
  .playbits-timeline-card::after,
  .arrow-right {
    display: none;
  }

  .timeline-cards-wrapper::after {
    height: 2px;
    top: 2%;
  }

  .timeline-cards-wrapper-copy {
    margin-top: 0;
    margin-top: initial;
    padding: 0px;
  }

  .timeline-cards-wrapper-copy::after {
    display: none;
  }

  .what-will-your-child-learn-txt-content,
  .cstem-txt-content {
    padding: 0px;
    border-right: 0;
    border-right: initial;
  }

  .child-learn-yt-video iframe {
    height: auto;
    width: 100%;
  }

  .scp-img-a img,
  .scp-img-b img {
    height: 50px;
    width: 50px;
  }

  .software-download-txt-icon p {
    font-size: 20px;
  }

  .wand-1-wrapper {
    padding: 30px 0px;
    width: 100%;
  }

  .playbit-card-icon {
    left: 37%;
  }

  .child-learn-yt-video {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/TaCo-Playbits/TaCoPlaybits.css"],"names":[],"mappings":"AAAA;EACE,yDAAwF;EACxF,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;EAChC,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;EAChC,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAU;EAAV,YAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,gCAAa;IAAb,eAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAa;IAAb,eAAa;EACf;AACF;;AAEA;EACE;IACE,yDAAgG;IAChG,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAmB;IAAnB,qBAAmB;IACnB,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,cAAkB;IAAlB,oBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,aAAiB;IAAjB,mBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,eAAmB;IAAnB,qBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".playbits-top-banner {\n  background-image: url(\"../../../../public/images/taco-playbits/playbits-top-banner.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  height: 27.6vw;\n}\n\n.pointers-auth-icons-wrapper {\n  border-right: 1px solid #cccccc;\n  padding: 0 15%;\n}\n\n.playbits-auth-icons {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding-top: 20px;\n}\n\n.playbits-auth-icons img {\n  height: 120px;\n  width: 120px;\n}\n\n.abt-playbits-pointers ul li {\n  text-align: justify;\n  padding-bottom: 20px;\n}\n\n.playbits-timeline-card {\n  background-color: #e7e6ea;\n  padding: 20px 30px;\n  height: 200px;\n  border-radius: 10px;\n  border-bottom: 2px solid #c4c3c5;\n  border-left: 2px solid #c4c3c5;\n}\n\n.playbits-card-title p {\n  font-size: 20px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.playbit-card-icon img {\n  height: 50px;\n  width: 50px;\n  background-color: #cbcbcb;\n}\n\n.timeline-cards-wrapper::after {\n  content: \"\";\n  position: absolute;\n  background-color: #cbcbcd;\n  width: 95%;\n  height: 3px;\n  top: 47%;\n  left: 3%;\n}\n\n/* Arrow Left */\n.timeline-cards-wrapper::before {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #cbcbcd;\n  top: 45.5%;\n  left: 2%;\n}\n\n.timeline-cards-wrapper-copy {\n  position: relative;\n}\n\n.timeline-cards-wrapper-copy::before {\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #cbcbcd;\n  top: 98%;\n  left: 14%;\n}\n\n.timeline-cards-wrapper-copy::after {\n  bottom: -2%;\n  top: unset;\n  width: 70%;\n  left: 15%;\n}\n\n/* Arrow right  */\n.arrow-right {\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 10px solid #cbcbcd;\n  position: absolute;\n  top: 45.5%;\n  right: -5%;\n}\n\n.arrow-right-copy {\n  top: 98%;\n  right: 8%;\n}\n.timeline-cards-wrapper-copy {\n  margin-top: 50px;\n}\n\n.playbit-card-icon {\n  position: absolute;\n  bottom: -15%;\n  left: 35%;\n  border-radius: 5px;\n  width: 65px;\n  padding: 7px;\n}\n\n.playbits-card-icon-a {\n  background: linear-gradient(to right, #2662c6, #4352bc);\n}\n\n.playbits-card-icon-b {\n  background: linear-gradient(to right, #4d4fbb, #6c42b0);\n}\n\n.playbits-card-icon-c {\n  background: linear-gradient(to right, #7741ae, #993ea3);\n}\n\n.playbits-timeline-card::after {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background-color: #cbcbcd;\n  border-radius: 12px;\n  border: 4px solid #6c42b0;\n  position: absolute;\n  left: 45%;\n  bottom: -36%;\n  z-index: 2;\n}\n\n.playbits-timeline-card-copy::after {\n  bottom: -34%;\n}\n\n/* What will your child learn */\n.child-learn {\n  background-color: #f5f6fb;\n}\n\n.what-will-your-child-learn-txt-content,\n.cstem-txt-content {\n  padding: 0 10%;\n}\n\n.what-will-your-child-learn-txt-content ul li,\n.cstem-txt-content ul li {\n  text-align: justify;\n  padding-bottom: 20px;\n}\n\n.cstem-txt-content ul li {\n  color: var(--dPink);\n}\n\n.cstem-txt-content {\n  border-right: 1px solid #000;\n}\n\n.cstem-txt-content ul li strong,\n.cstem-txt-content ul li::marker {\n  color: var(--dBlue);\n}\n\n.cstem-txt-row p {\n  color: var(--dBlue);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* Video section  */\n.video-playbits-soft {\n  background-color: #f5f6fb;\n}\n\n.rec-que-txt p {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.rec-que-txt p {\n  color: var(--dBlue);\n}\n\n.software-download-txt-icon p {\n  color: #5b5c5e;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.software-compatible-platforms {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  column-gap: 70px;\n}\n\n.scp-img-a img,\n.scp-img-b img {\n  height: 70px;\n  width: 70px;\n}\n\n.scp-img-a p,\n.scp-img-b p {\n  color: var(--dBlue);\n  font-weight: 500;\n}\n\n.scp-img-a::after {\n  content: \"\";\n  position: absolute;\n  background-color: #9fa0a5;\n  width: 2px;\n  height: 50px;\n  left: 51%;\n  top: 40%;\n}\n\n.wand-1-wrapper {\n  background-color: #f5f6fb;\n  padding: 30px 60px;\n  border-radius: 15px;\n  background-color: #f5f6fb;\n  padding: 30px 60px;\n  border-radius: 15px;\n  width: 70%;\n  margin: 0 auto;\n}\n\n.wand-sequence p {\n  color: var(--dBlue);\n  font-size: 25px;\n  font-weight: 600;\n}\n\n.wand-icons {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 10%;\n  justify-content: center;\n}\n\n.wand-icons img {\n  height: 120px;\n  width: 120px;\n}\n\n@media (max-width: 1024px) {\n  .pointers-auth-icons-wrapper {\n    border: unset;\n    margin-bottom: 50px;\n  }\n\n  .wand-1-wrapper {\n    width: 100%;\n  }\n\n  .cstem-gif-content {\n    margin-bottom: 20px;\n  }\n\n  .cstem-txt-content {\n    border: unset;\n  }\n}\n\n@media (max-width: 576px) {\n  .playbits-top-banner {\n    background-image: url(\"../../../../public/images/taco-playbits/taco-playbits-mobile-banner.jpg\");\n    height: 127.2vw;\n  }\n\n  .cstem-gif-content img {\n    height: auto;\n    width: 100%;\n  }\n\n  .playbits-video-tutorials {\n    flex-wrap: wrap;\n  }\n\n  .pointers-auth-icons-wrapper {\n    border-right: unset;\n    padding: unset;\n  }\n\n  .playbits-auth-icons {\n    padding-top: unset;\n  }\n\n  .playbits-timeline-card {\n    margin: 40px;\n  }\n\n  .timeline-cards-wrapper {\n    padding-top: 30px;\n  }\n\n  .timeline-cards-wrapper::before,\n  .playbits-timeline-card::after,\n  .arrow-right {\n    display: none;\n  }\n\n  .timeline-cards-wrapper::after {\n    height: 2px;\n    top: 2%;\n  }\n\n  .timeline-cards-wrapper-copy {\n    margin-top: unset;\n    padding: 0px;\n  }\n\n  .timeline-cards-wrapper-copy::after {\n    display: none;\n  }\n\n  .what-will-your-child-learn-txt-content,\n  .cstem-txt-content {\n    padding: 0px;\n    border-right: unset;\n  }\n\n  .child-learn-yt-video iframe {\n    height: auto;\n    width: 100%;\n  }\n\n  .scp-img-a img,\n  .scp-img-b img {\n    height: 50px;\n    width: 50px;\n  }\n\n  .software-download-txt-icon p {\n    font-size: 20px;\n  }\n\n  .wand-1-wrapper {\n    padding: 30px 0px;\n    width: 100%;\n  }\n\n  .playbit-card-icon {\n    left: 37%;\n  }\n\n  .child-learn-yt-video {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
